import BasicRoute from "components/routes/BasicRoute";
import ClienteConsulta from "entity/Cliente/components/ClienteConsulta";
import ClienteForm from "entity/Cliente/components/ClienteForm";

export default function RoutesMenusCliente() {

    return <>
        <BasicRoute
            perfilAuth={['r9jrEQXznNgjrZTGCfch', 'RECT03jkyTQW9B2OMz47']}//admin ou tecnico
            uid="consultaCliente"
            route="consulta-clientes"

            menuProps={{
                text: "Clientes",
                sequence: "111112",
                iconName: 'Ballot',
                parent: {
                    uid: "parentCadastros",
                    text: "Cadastros",
                    sequence: "222222",
                    iconName: 'Edit'
                }
            }}

            element={<ClienteConsulta />}
        />
        <BasicRoute
            uid="cliente"
            route="_cliente"
            element={<ClienteForm />}
        />
    </>;
}
